import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../hooks/useProfile';
import { Check } from 'lucide-react';
import { toast } from 'sonner';
import { getAuth } from 'firebase/auth';

export default function Subscribe() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleSubscribe = async () => {
    if (!auth.currentUser) {
      toast.error('Vous devez être connecté pour souscrire à un abonnement');
      navigate('/login');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      if (!auth.currentUser) {
        throw new Error('Utilisateur non connecté');
      }

      const payload = {
        userId: auth.currentUser.uid,
        email: auth.currentUser.email,
      };

      const response = await fetch('/.netlify/functions/stripe-checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || data.details || 'Une erreur est survenue lors de la création de la session de paiement.');
        return;
      }

      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error('Aucune URL de paiement reçue');
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la connexion au service de paiement.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Abonnez-vous à VCard Pro
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Accédez à toutes les fonctionnalités premium
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-xl">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900">Premium</h3>
              <div className="mt-4">
                <div className="flex items-center">
                  <Check className="h-5 w-5 text-green-500" />
                  <span className="ml-2">VCard personnalisable</span>
                </div>
                <div className="flex items-center mt-2">
                  <Check className="h-5 w-5 text-green-500" />
                  <span className="ml-2">Statistiques détaillées</span>
                </div>
                <div className="flex items-center mt-2">
                  <Check className="h-5 w-5 text-green-500" />
                  <span className="ml-2">Support prioritaire</span>
                </div>
              </div>
            </div>

            <button
              onClick={handleSubscribe}
              disabled={loading}
              className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Chargement...' : 'Souscrire - 1.99€/mois'}
            </button>
            {error && (
              <div className="mt-2 text-center text-sm text-red-600">
                {error}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
